import React from "react";
import "./BillingRollbackContainer.less";
import { Col, Row } from "antd";
import BillingRollback from "../../components/BillingRollback/BillingRollback";
import { hasAccess } from "../../components/RolesModule/hasAccess";
import { MENU_BILLING_ROLLBACK, MENU_BILLING_ROLLBACK_WRITE } from "../../lib/const/permissions";
import ErrorPage from "../../components/ErrorPage/ErrorPage";

const BillingRollbackContainer = () => {
  

  if (hasAccess(MENU_BILLING_ROLLBACK, MENU_BILLING_ROLLBACK_WRITE)) {
    return (
      <div className="container_height billing-rollback">
        <div className="inner-row">
          <Row justify="space-between" align="middle">
            <Col>
              <h1>Откат биллинга</h1>
            </Col>
          </Row>
          <BillingRollback />
        </div>
      </div>
    );
  }
  return <ErrorPage />;
};

export default BillingRollbackContainer;
